"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.star = void 0;
var star = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1.3l2.388,6.722H18.8l-5.232,3.948l1.871,6.928L10,14.744l-5.438,4.154l1.87-6.928L1.199,8.022h6.412L10,1.3z"
    }
  }]
};
exports.star = star;